import type { StepType } from './sharedTypes'

/**
 * Build global IPERIA steps based on current location
 * This allows navigation between main sections (Verification, Documents, Parent Employeur, NIR, Signature)
 */
export function buildGlobalIperiaSteps(globalId: string): StepType[] {
  const steps: StepType[] = [
    {
      label: 'Vérification',
      url: `/iperia/${globalId}/verification`,
    },
    {
      label: 'Documents',
      url: `/iperia/${globalId}/documents`,
    },
    {
      label: 'Parent Employeur',
      url: `/iperia/${globalId}/parent-employeur`,
    },
    {
      label: 'N° sécurité sociale',
      url: `/iperia/${globalId}/nir`,
    },
    {
      label: 'Signature',
      url: `/iperia/${globalId}/signature`,
    },
  ]

  return steps
}

/** Side stepper for the parent employer portal (JWT link). */
export function buildParentPortalSteps(): StepType[] {
  return [
    {
      label: 'Signature',
      url: 'parent',
    },
    {
      label: 'Succès',
      url: 'success',
    },
  ]
}

/**
 * Build local steps for Verification section (sub-steps)
 */
export function buildVerificationSteps(globalId: string): StepType[] {
  return [
    {
      label: 'Identité',
      url: `/iperia/${globalId}/verification`,
    },
    {
      label: 'Adresse',
      url: `/iperia/${globalId}/verification/adresse`,
    },
    {
      label: 'Formation',
      url: `/iperia/${globalId}/verification/formation`,
    },
    {
      label: 'Récapitulatif',
      url: `/iperia/${globalId}/verification/recapitulatif`,
    },
  ]
}

/**
 * Build local steps for Parent Employeur section (sub-steps)
 */
export function buildParentEmployeurSteps(globalId: string): StepType[] {
  return [
    {
      label: 'Informations',
      url: `/iperia/${globalId}/parent-employeur`,
    },
    {
      label: 'Adresse',
      url: `/iperia/${globalId}/parent-employeur/adresse`,
    },
  ]
}
